module.exports = function() {
  return new Worker(__webpack_public_path__ + "b9bb2919ab53e188091c.worker.js");
};